import type {
    DevicePlugin,
    DeviceId,
    DeviceInfo,
    BatteryInfo,
    GetLanguageCodeResult,
} from './definitions';
import { HuaweiBridgeClient } from './huawei-bridge-client';

/**
 * DeviceHuawei implements the same DevicePlugin interface as
 * @capacitor/device, routing calls through the Huawei JS Bridge.
 *
 * All four methods (getId, getInfo, getBatteryInfo, getLanguageCode)
 * use the standard request-response bridge — no push callbacks needed.
 */
export class DeviceHuawei implements DevicePlugin {
    private bridge: HuaweiBridgeClient;

    constructor() {
        this.bridge = HuaweiBridgeClient.getInstance();
    }

    async getId(): Promise<DeviceId> {
        return this.bridge.call('getId');
    }

    async getInfo(): Promise<DeviceInfo> {
        return this.bridge.call('getInfo');
    }

    async getBatteryInfo(): Promise<BatteryInfo> {
        return this.bridge.call('getBatteryInfo');
    }

    async getLanguageCode(): Promise<GetLanguageCodeResult> {
        return this.bridge.call('getLanguageCode');
    }
}
